var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotTrustIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4826_5170)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8606 22.3797C35.151 22.5937 35.2129 23.0026 34.999 23.293L30.4268 29.4982C30.2128 29.7886 29.8039 29.8506 29.5135 29.6366C29.223 29.4226 29.1611 29.0137 29.3751 28.7233L33.9473 22.5181C34.1613 22.2276 34.5702 22.1657 34.8606 22.3797Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.421877
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3629 29.5724C30.1078 29.8275 29.6942 29.8275 29.4391 29.5724L27.1529 27.2863C26.8979 27.0312 26.8979 26.6176 27.1529 26.3625C27.408 26.1074 27.8216 26.1074 28.0767 26.3625L30.3628 28.6486C30.6179 28.9037 30.6179 29.3173 30.3629 29.5724Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.421877
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4826_5170)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.6328,
    cy: 23.958,
    r: 16,
    fill: "url(#paint0_linear_4826_5170)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2858 18.9489C37.7412 18.4934 37.7412 17.755 37.2858 17.2996C36.8303 16.8441 36.0919 16.8441 35.6365 17.2996L30.6332 22.3029L25.6299 17.2996C25.1745 16.8441 24.4361 16.8441 23.9806 17.2996C23.5252 17.755 23.5252 18.4934 23.9806 18.9489L28.9839 23.9521L23.9744 28.9617C23.519 29.4171 23.519 30.1555 23.9744 30.611C24.4298 31.0664 25.1682 31.0664 25.6237 30.611L30.6332 25.6014L35.6427 30.611C36.0982 31.0664 36.8366 31.0664 37.292 30.611C37.7475 30.1555 37.7475 29.4171 37.292 28.9617L32.2825 23.9521L37.2858 18.9489Z",
    fill: "url(#paint1_linear_4826_5170)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2858 17.2996L37.1797 17.4056L37.2858 17.2996ZM37.2858 18.9489L37.1797 18.8428L37.2858 18.9489ZM35.6365 17.2996L35.5304 17.1935V17.1935L35.6365 17.2996ZM30.6332 22.3029L30.5271 22.4089L30.6332 22.515L30.7393 22.4089L30.6332 22.3029ZM25.6299 17.2996L25.5238 17.4056L25.6299 17.2996ZM23.9806 17.2996L24.0867 17.4056V17.4056L23.9806 17.2996ZM23.9806 18.9489L24.0867 18.8428L23.9806 18.9489ZM28.9839 23.9521L29.09 24.0582L29.1961 23.9521L29.09 23.8461L28.9839 23.9521ZM23.9744 28.9617L24.0805 29.0678H24.0805L23.9744 28.9617ZM23.9744 30.611L24.0805 30.5049H24.0805L23.9744 30.611ZM25.6237 30.611L25.5176 30.5049H25.5176L25.6237 30.611ZM30.6332 25.6014L30.7393 25.4954L30.6332 25.3893L30.5271 25.4954L30.6332 25.6014ZM35.6427 30.611L35.7488 30.5049L35.6427 30.611ZM37.292 30.611L37.186 30.5049L37.292 30.611ZM37.292 28.9617L37.186 29.0678V29.0678L37.292 28.9617ZM32.2825 23.9521L32.1764 23.8461L32.0703 23.9521L32.1764 24.0582L32.2825 23.9521ZM37.1797 17.4056C37.5766 17.8025 37.5766 18.4459 37.1797 18.8428L37.3918 19.0549C37.9058 18.5409 37.9058 17.7075 37.3918 17.1935L37.1797 17.4056ZM35.7426 17.4056C36.1394 17.0088 36.7828 17.0088 37.1797 17.4056L37.3918 17.1935C36.8778 16.6795 36.0444 16.6795 35.5304 17.1935L35.7426 17.4056ZM30.7393 22.4089L35.7426 17.4056L35.5304 17.1935L30.5271 22.1968L30.7393 22.4089ZM25.5238 17.4056L30.5271 22.4089L30.7393 22.1968L25.736 17.1935L25.5238 17.4056ZM24.0867 17.4056C24.4836 17.0088 25.127 17.0088 25.5238 17.4056L25.736 17.1935C25.222 16.6795 24.3886 16.6795 23.8746 17.1935L24.0867 17.4056ZM24.0867 18.8428C23.6899 18.4459 23.6899 17.8025 24.0867 17.4056L23.8746 17.1935C23.3606 17.7075 23.3606 18.5409 23.8746 19.0549L24.0867 18.8428ZM29.09 23.8461L24.0867 18.8428L23.8746 19.0549L28.8779 24.0582L29.09 23.8461ZM24.0805 29.0678L29.09 24.0582L28.8779 23.8461L23.8683 28.8556L24.0805 29.0678ZM24.0805 30.5049C23.6836 30.108 23.6836 29.4646 24.0805 29.0678L23.8683 28.8556C23.3543 29.3696 23.3543 30.203 23.8683 30.717L24.0805 30.5049ZM25.5176 30.5049C25.1207 30.9018 24.4773 30.9018 24.0805 30.5049L23.8683 30.717C24.3823 31.231 25.2157 31.231 25.7297 30.717L25.5176 30.5049ZM30.5271 25.4954L25.5176 30.5049L25.7297 30.717L30.7393 25.7075L30.5271 25.4954ZM35.7488 30.5049L30.7393 25.4954L30.5271 25.7075L35.5367 30.717L35.7488 30.5049ZM37.186 30.5049C36.7891 30.9018 36.1457 30.9018 35.7488 30.5049L35.5367 30.717C36.0507 31.231 36.8841 31.231 37.3981 30.717L37.186 30.5049ZM37.186 29.0678C37.5828 29.4646 37.5828 30.108 37.186 30.5049L37.3981 30.717C37.9121 30.203 37.9121 29.3696 37.3981 28.8556L37.186 29.0678ZM32.1764 24.0582L37.186 29.0678L37.3981 28.8556L32.3885 23.8461L32.1764 24.0582ZM37.1797 18.8428L32.1764 23.8461L32.3885 24.0582L37.3918 19.0549L37.1797 18.8428Z",
    fill: "url(#paint2_linear_4826_5170)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4826_5170",
    x: 5.63281,
    y: 0.958008,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.73568 0 0 0 0 0.808576 0 0 0 0 0.860645 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4826_5170"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4826_5170",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4826_5170",
    x1: 30.6328,
    y1: -15.0163,
    x2: 30.6328,
    y2: 62.5878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4826_5170",
    x1: 23.1777,
    y1: 27.5007,
    x2: 41.5229,
    y2: 13.6472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84AAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336ECA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4826_5170",
    x1: 23.1777,
    y1: 27.5007,
    x2: 41.5229,
    y2: 13.6472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84AAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336ECA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4826_5170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.632812 0.0292969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotTrustIcon);
export default __webpack_public_path__ + "static/media/NotTrustIcon.fc16d59c90468302edbcfcf6b84adfe7.svg";
export { ForwardRef as ReactComponent };